<template>
  <div>
    <v-card
      v-if="!!internalReference && !reference.dose"
      @click="openReferenceCard()"
      height="70px"
      class="vetalfa-pointer ma-0 my-3 pa-2 mx-2"
    >
      <v-row aling="center" class="ma-0 pa-0 vetalfa-row">
        <v-col class="ma-0 pa-0" cols="2">
          <v-img
            contain
            :src="getImageForRef(reference)"
            height="24"
            max-width="24"
          ></v-img>
        </v-col>
        <v-col class="ma-0 pa-0" cols="9">
          <p v-bind:class="getCarouselItemClass()">
            {{ reference.name }}
          </p>
          <p class="ma-0 pa-0 mt-1 items-description-label">
            {{ reference.category }}
          </p>
        </v-col>
        <v-col class="ma-0 pa-0" cols="1">
          <v-row justify="end" align="center" class="ma-0 pa-0 vetalfa-row">
            <v-icon x-small color="#747678">{{ mdiChevronRight }}</v-icon>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <vetalfa-dose-card
      isCard
      v-else-if="!!internalReference && !!reference.dose"
      class="mb-4 mt-2 ma-0 pa-0"
      :isDrugsManagement="isAdmin"
      :prop="{
        ...this.reference.dose,
        title: this.reference.name,
        path: this.reference.path,
      }"
    ></vetalfa-dose-card>
    <v-card
      v-else-if="!!hasEvidence"
      @click="openReferenceCard()"
      class="ma-2 pa-0 reference-card"
    >
      <v-row class="ma-0 pa-0 pa-3">
        <v-col class="ma-0 pa-0 pr-1" :cols="internalReference ? 11 : 8">
          <p class="ma-0 pa-0">
            {{ `${_getLabel("REFERENCE_CARD_NAME")}: ${reference.name}` }}
          </p>
          <p v-if="!internalReference" class="ma-0 pa-0 mt-2">
            {{ `${_getLabel("REFERENCE_CARD_YEAR")}: ${reference.year}` }}
          </p>
          <p v-if="!internalReference" class="ma-0 pa-0 mt-2">
            {{ `${reference_source}: ${_capitalize(reference.magazine)}` }}
          </p>
          <p v-if="!internalReference" class="ma-0 pa-0 mt-2">
            {{ `${_getLabel("REFERENCE_CARD_EVIDENCE_LEVEL")}: ` }}
            <span>{{ reference.level }}</span>
          </p>
          <p
            v-if="reference.addendum && !internalReference"
            class="ma-0 pa-0 mt-2"
          >
            {{ `${_getLabel("ADDENDA")}: ${reference.addendum}` }}
          </p>
          <p v-if="internalReference" class="ma-0 pa-0 mt-2">
            {{ `${_getLabel("CATEGORY")}: ${reference.category}` }}
          </p>
          <p
            v-if="internalReference && !!reference.description"
            class="ma-0 pa-0 mt-2"
          >
            {{ `${_getLabel("DETAILS")}: ${reference.description}` }}
          </p>
        </v-col>
        <v-col v-if="!internalReference" cols="3" class="ma-0 pa-0">
          <v-row
            class="ma-0 pa-0 reference-card-full-height"
            align="center"
            justify="center"
          >
            <v-img :src="pyramid_image" :lazy-src="pyramid_image" class></v-img>
          </v-row>
        </v-col>
        <v-col cols="1" class="ma-0 pa-0">
          <v-row
            class="ma-0 pa-0 reference-card-full-height"
            align="center"
            justify="center"
          >
            <v-icon size="15" color="#004662">{{ mdiChevronRight }}</v-icon>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <v-card v-else class="ma-2 pa-0 reference-card-no-evidence">
      <v-row class="ma-0 pa-0 pa-3">
        <v-col class="ma-0 pa-0 pr-1" cols="12">
          <p class="ma-0 pa-0">
            {{ `${_getLabel("REFERENCE_CARD_NAME")}: ${reference.name}` }}
          </p>
          <p v-if="!!reference.year" class="ma-0 pa-0 mt-2">
            {{ `${_getLabel("REFERENCE_CARD_YEAR")}: ${reference.year}` }}
          </p>
          <p v-if="!!reference.magazine" class="ma-0 pa-0 mt-2">
            {{ `${reference_source}: ${_capitalize(reference.magazine)}` }}
          </p>
          <p v-if="reference.level !== 0" class="ma-0 pa-0 mt-2">
            {{ `${_getLabel("REFERENCE_CARD_EVIDENCE_LEVEL")}: ` }}
            <span class="reference-card-guideline">{{
              _getLabel("REFERENCE_WITHOUT_APPLICATION_BOOK").includes(
                reference.level
              )
                ? _getLabel("REFERENCE_WITHOUT_APPLICATION")
                : reference.level
            }}</span>
          </p>
          <p v-if="reference.addendum" class="ma-0 pa-0 mt-2">
            {{ `${_getLabel("ADDENDA")}: ${reference.addendum}` }}
          </p>
          <p v-if="_validURL(reference.link)" class="ma-0 pa-0 mt-2">
            {{ `${_getLabel("REFERENCE_CARD_SITE")}: ` }}
            <span
              @click="
                openExternalUrl({ url: reference.link, inAppBrowser: true })
              "
              class="reference-card-link"
              >{{ reference.link }}</span
            >
          </p>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<style>
.reference-card {
  border-radius: 7px;
  background-color: white;
  cursor: pointer;
  font-size: 14px;
  font-weight: 0;
  color: #393a3a;
}
.reference-card-no-evidence {
  border-radius: 7px;
  background-color: white;
  font-size: 14px;
  cursor: unset !important;
  font-weight: 0;
  color: #393a3a;
}
.reference-card-full-height {
  height: 100%;
  width: 100%;
}
.reference-card-guideline {
  font-style: italic;
  font-weight: 600;
}
.reference-card-link {
  color: #004662;
  font-style: italic;
  font-weight: 600;
  letter-spacing: 0;
  text-decoration: underline;
  cursor: pointer;
}
</style>

<script>
import images from "@/constants/images.js";
import { mdiChevronRight } from "@mdi/js";
import { mapActions } from "vuex";
import sectionsEnum from "@/constants/sections.enum.js";
export default {
  name: "ReferenceCard",
  props: {
    reference: { type: Object, default: null, required: true },
  },
  methods: {
    ...mapActions("drugs", ["openReference"]),
    ...mapActions("general", ["openExternalUrl", "routePathRedirect"]),
    openReferenceCard() {
      if (this.internalReference && this.$route.name != "topics-management") {
        this.routePathRedirect({
          path: this.reference.path,
          from: { ...this.$route },
        });
      } else if (this.hasEvidence && this.$route.name != "topics-management") {
        this.openReference({
          reference: this.reference,
          from: { ...this.$route },
        });
      }
    },

    getCarouselItemClass() {
      return (
        (!!this.reference.description &&
        this.reference.description.trim() !=
          this._getLabel("ACTIVE_PRINCIPLE_SINGULAR")
          ? "items-products-title"
          : "items-title") + " ma-0 pa-0 items-two-lines-clamp"
      );
    },
    getImageForRef(reference) {
      return this.sections.find((s) => {
        return (
          s.name.replace("e Escores", "").trim() ===
          reference.category.replace("| Doses", "").trim()
        );
      }).image;
    },
  },
  computed: {
    isAdmin() {
      return process.env.VUE_APP_ENV === "admin";
    },
    hasEvidence() {
      if (this.reference.level === 0) {
        return false;
      }
      return !isNaN(this.reference.level) || this.reference.levelNumber;
    },
    internalReference() {
      return !!this.reference.type && this.reference.type == 1;
    },
    reference_source() {
      return this.hasEvidence
        ? this._getLabel("REFERENCE_CARD_MAGAZINE")
        : this._getLabel("REFERENCE_CARD_SOURCE");
    },
    pyramid_image() {
      let level = this.reference.levelNumber || Number(this.reference.level);
      if (this.hasEvidence) {
        switch (level) {
          case 1:
            return this.images.PYRAMID_ONE;
          case 2:
            return this.images.PYRAMID_TWO;
          case 3:
            return this.images.PYRAMID_THREE;
          case 4:
            return this.images.PYRAMID_FOUR;
          case 5:
            return this.images.PYRAMID_FIVE;
        }
      }
    },
  },
  data() {
    return {
      sections: sectionsEnum.sections,
      images,
      mdiChevronRight,
    };
  },
};
</script>